module.exports = __webpack_public_path__ + "static/media/expander_active.8f748a95.svg";